<template lang="pug">
    .contacts(v-if="content")
        .page__wr
            .contacts__wr
                .contacts__map
                    #contactsMap
                        .contacts__map-button(v-on:click="hideMap($event, content.initMapConfig)")
                            SvgIcon.contacts__map-button-icon(name="close" width="34" height="34")
                    .contacts__map-block
                        p.contacts__map-description Нажмите для просмотра карты
                        .contacts__map-circle(v-on:click="showMap($event)")
                            SvgIcon.contacts__section-map-circle-icon(name="plus")
                .contacts__block
                    h2.contacts__headline(v-html='content.subtitle')
                    .contacts__scroll
                        .contacts__scroll-wr
                            .contacts__contacts
                                .contacts__contact-wr
                                    .contacts__contact
                                        SvgIcon.contacts__contact-icon.contacts__contact-icon--email(name="email" width="28" height="21")
                                        a.contacts__contact-link(:href="content.email.link") {{ content.email.title }}
                                .contacts__contact-wr(v-for="(item, index) in content.addreses" :key="index")
                                    .contacts__contact
                                        SvgIcon.contacts__contact-icon(name="location" width="22" height="29")
                                        .contacts__contact-address(v-html="item.name")
                                    .contacts__contact(v-if="item.phone.length" v-for="(phone, index) in item.phone" :key="index")
                                        SvgIcon.contacts__contact-icon(name="phone" width="18" height="29")
                                        a.contacts__contact-link(:href="phone.link") {{ phone.text }}
                            form.contacts__form(v-on:submit.prevent="submit" :class="{'contacts__form--show': !formSend}")
                                .contacts__form-block
                                    input.contacts__form-input(type="text" placeholder="Ваше имя" v-model="name" required)
                                    input.contacts__form-input(type="email" placeholder="E-mail" v-model="email" required)
                                input.contacts__form-input(type="tel" name="phone" v-model="phone" v-mask="'+7(###)-###-##-##'" placeholder="+7(____)-____-___-___" required)
                                textarea.contacts__form-textarea(placeholder="Комментарий" v-model="comment" required)
                                button.contacts__button(type="submit") Отправить
                                .contacts__form-description
                                    p.contacts__form-description-text Нажимая кнопку «Отправить», я даю согласие на
                                        router-link(to="/politika-konfidencial-nosti" target="_blank").contacts__form-description-text--link  обработку персональных данных
                            .contacts__form-send(:class="{'contacts__form-send--show': formSend}")
                                h5.contacts__form-send-text Форма успешно отправлена!
                                h5.contacts__form-send-text Скоро мы свяжемся с Вами
                    Samedia.contacts__samedia
</template>

<script>
  import EventBus from '@/eventBus';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import Samedia from '@/components/common/samedia/Samedia.vue'

  import '@/components/contacts/contacts.styl';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {YaHelpersVue} from '@/mixins/YaHelpersVue';
  import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';
  import {FormHelpersVue} from '@/mixins/FormHelpersVue';
  import {ScrollbarHelpers} from "@/mixins/ScrollbarHelpers";

  export default {
    name: 'Contacts',

    mixins: [AjaxHelpersVue, YaHelpersVue, FormHelpersVue, ScrollbarHelpers],

    data() {
      return {
        isMapInit: false,
        content: null,
        name: '',
        phone: '',
        email: '',
        comment: '',
        formSend: false,
        windowWidth: 0
      }
    },

    components: {
        SvgIcon,
        Samedia
    },

    created() {
      // Загрузка данных для страницы
        this.windowWidth = $(window).width();
        this.$nextTick(() => {
            // this.request(this.$router.currentRoute.path);
        });
    },

    mounted() {
    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
          // экземпляр компонента доступен как `vm`
          EventBus.$emit('pagePreloaderShow');
          vm.scrollbarCheck();
          setTimeout(() => {
              EventBus.$emit('setMenuTopActiveClass', to.path);
              vm.request(to.path);
          }, 50);
      })
    },

    beforeRouteUpdate(to, from, next) {
        EventBus.$emit('pagePreloaderShow');
        this.scrollbarCheck();
        setTimeout(() => {
            EventBus.$emit('setMenuTopActiveClass', to.path);
            this.request(to.path);
            next();
        }, 50);
    },

    methods: {
      request(url) {
        this.req('ContactsPage:getContactsPage', {url}, res => {
          this.content = res.content;
            EventBus.$emit('pagePreloaderHide');
          if(this.checkProperty(res.content.initMapConfig)) {
            this.$nextTick(() => {
              if(!this.isMapInit) {
                this.initMapLocal('#contactsMap', res.content.initMapConfig);
              }
              this.checkOverflow(url);
              if(this.windowWidth > 760) {
                this.customScrollbarInit('.contacts__scroll');
              }
            })
          }
        });
      },

      initMapLocal(block, initMapConfig) {
        this
          .initMap(block, initMapConfig)
          // Когда карта загружена
          .then(() => {
            // Добавляем на карту placemarks
            this.addAllPlacemarks(initMapConfig.coords).then(() => {

              setTimeout(() => {
                $('.contacts__map-preloader').addClass('contacts__map-preloader--hide');
              }, 750);
            });

            this.isMapInit = true;
          });
      },

      submit() {
        let data = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          comment: this.comment
        };

        this.submitForm('Common:sendContactsForm', data, res => {
          this.name  = '';
          this.email = '';
          this.phone = '';
          this.comment = '';
          if(res.status === 'ok') {
              this.formSend = true;
          }
        });
      },
    }
  }
</script>
